import React, { useState } from "react";
import { FlagIcon } from "@heroicons/react/24/solid";

export default function ReferralConsultationHistory() {
  const milestones = [
    {
      milestone: "First milestone",
      reward: 500,
      consultations: [
        { title: "First consultation completed", date: "12 DEC 4:10 PM" },
      ],
    },
    {
      milestone: "Second milestone",
      reward: 500,
      consultations: [
        { title: "Second consultation completed", date: "15 DEC 4:10 PM" },
      ],
    },
    {
      milestone: "Third milestone",
      reward: 500,
      consultations: [
        { title: "Third consultation completed", date: "20 DEC 4:10 PM" },
      ],
    },
    {
      milestone: "Fourth milestone",
      reward: 500,
      consultations: [
        { title: "Fourth consultation completed", date: "22 DEC 4:10 PM" },
      ],
    },
  ];

  // Combine all consultations into a single array
  const allConsultations = milestones.flatMap((m) => m.consultations);

  // State to toggle timeline visibility
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm dark:border-gray-700 dark:bg-gray-900">
      {/* Header */}
      <h2 className="text-lg font-semibold mb-4">Referral View</h2>

      {/* User Section */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <img
            src="https://i.pravatar.cc/40?img=3"
            alt="User"
            className="w-10 h-10 rounded-full"
          />
          <p className="font-medium text-gray-800 dark:text-gray-200">
            Prem Kumar
          </p>
        </div>
        <span className="rounded-full bg-green-100 text-green-600 px-3 py-1 text-sm font-medium">
          ₹ 1500
        </span>
      </div>

      {/* Clickable header to toggle timeline */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 mb-4 text-sm text-gray-700 dark:text-gray-300 w-full text-left"
      >
        <FlagIcon className="w-4 h-4 text-blue-500" />
        You have earned ₹1500 for your referrals
      </button>

      {/* Timeline (conditionally rendered) */}
      {isOpen && (
        <div className="space-y-4">
          {allConsultations.map((c, idx) => (
            <div key={idx} className="flex gap-3">
              {/* Timeline marker */}
              <div className="flex flex-col items-center">
                <span className="w-3 h-3 rounded-full border-2 border-gray-400 bg-white" />
                {idx !== allConsultations.length - 1 && (
                  <span className="h-full w-px bg-gray-300" />
                )}
              </div>

              {/* Content */}
              <div>
                <p className="font-medium text-gray-800 dark:text-gray-100">
                  {c.title}
                </p>
                <p className="text-xs text-gray-500 dark:text-gray-400">
                  {c.date}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
